import { SyncDirection } from "../../../../../../../common/sesh_types";
import GoogleCalendarLogo from "../../components/google_calendar_logo";

export default function SyncTypeTag(props: { syncType: SyncDirection }) {
	switch (props.syncType) {
		case SyncDirection.Outbound:
			return (
				<div className="tag tag-dark-gray gap-1.5">
					<span className="sesh-text">sesh</span>
					<i className="fas fa-long-arrow-alt-right"></i>
					<GoogleCalendarLogo />
				</div>
			);
		case SyncDirection.Inbound:
			return (
				<div className="tag tag-dark-gray gap-1.5">
					<GoogleCalendarLogo />
					<i className="fas fa-long-arrow-alt-right"></i>
					<span className="sesh-text">sesh</span>
				</div>
			);
		case SyncDirection.Bidirectional:
			return (
				<div className="tag tag-dark-gray gap-1.5">
					<span className="sesh-text">sesh</span>
					<i className="fas fa-arrows-alt-h"></i>
					<GoogleCalendarLogo />
				</div>
			);
	}
}
